import { getItemsFromCollection } from "directus/src/operations";
import { useQuery } from "@tanstack/react-query";

export function useItemBySlug(collection, slug, options = {}) {
  return useQuery({
    queryKey: [collection, "slug", slug],
    queryFn: async () => {
      const query = {
        fields: ["name"],
        filter: { project_id: { _eq: slug } },
        limit: 1,
      };

      const response = await getItemsFromCollection(collection, query);
      return response?.[0] || null;
    },
    enabled: !!(collection && slug),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
